import type { LogoProps } from '../../logo.types'
import { logos, symbols } from './logos'

type LogoRaiaProps = LogoProps & {
  onlySymbol?: boolean
}

export const LogoRaia = (props: LogoRaiaProps) => {
  const { size, type, onlySymbol = false } = props

  const SvgComponent = logos[type][size]

  const SymbolComponent = symbols[type][size]

  return onlySymbol ? SymbolComponent : SvgComponent
}
